var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5336 73.7412L55.9113 20.0077C53.3451 15.3528 46.655 15.3528 44.0888 20.0078L14.4665 73.7412C11.9865 78.2399 15.2408 83.75 20.3778 83.75H79.6224C84.7594 83.75 88.0137 78.2399 85.5336 73.7412ZM62.4794 16.3869C57.0618 6.55972 42.9383 6.55973 37.5208 16.3869L7.89845 70.1204C2.6628 79.6176 9.53298 91.25 20.3778 91.25H79.6224C90.4672 91.25 97.3373 79.6176 92.1017 70.1204L62.4794 16.3869Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.0001 29.5103C52.0711 29.5103 53.7501 31.1893 53.7501 33.2603V62.6875C53.7501 64.7586 52.0711 66.4375 50.0001 66.4375C47.929 66.4375 46.2501 64.7586 46.2501 62.6875V33.2603C46.2501 31.1893 47.929 29.5103 50.0001 29.5103Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M45.7276 72.8435C45.7276 70.4828 47.6418 68.573 49.9984 68.573C52.3565 68.573 54.2691 70.4842 54.2691 72.8435C54.2691 75.2009 52.3588 77.1145 49.9984 77.1145C47.6395 77.1145 45.7276 75.2023 45.7276 72.8435ZM49.9984 76.073C51.7797 76.073 53.2276 74.6292 53.2276 72.8435C53.2276 71.0607 51.7821 69.6145 49.9984 69.6145C48.2133 69.6145 46.7691 71.0621 46.7691 72.8435C46.7691 74.6277 48.2157 76.073 49.9984 76.073Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0006 75.4325C51.4306 75.4325 52.5891 74.2735 52.5891 72.844C52.5891 71.414 51.4306 70.2555 50.0006 70.2555C48.5711 70.2555 47.4122 71.414 47.4122 72.844C47.4122 74.2735 48.5711 75.4325 50.0006 75.4325Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.d3cf202c258c26095bf73b290a32f691.svg";
export { ForwardRef as ReactComponent };